import ActivityMetrics from './ActivityMetrics.page';

export default ActivityMetrics;
